
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.647 16c.471 0 .853.448.853 1s-.382 1-.853 1H4.353c-.471 0-.853-.448-.853-1s.382-1 .853-1zm0-5c.471 0 .853.448.853 1s-.382 1-.853 1H4.353c-.471 0-.853-.448-.853-1s.382-1 .853-1zm0-5c.471 0 .853.448.853 1s-.382 1-.853 1H4.353C3.882 8 3.5 7.552 3.5 7s.382-1 .853-1z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    